import { COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function createPolicyCopy(body) {
    const response = await axios.post(COMMISSIONS_ENDPOINT + '/createComissionPolicyCopy', body);
    return response
}